<template>
  <div :class="[$style.avatar, $style[size]]">
    <slot>
      <span v-if="text" :style="{ backgroundColor }" aria-hidden="true">{{ text }}</span>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
      validator: (value) => {
        return value.length <= 2;
      },
    },
    backgroundColor: { type: String, required: true },
    size: {
      type: String,
      default: "medium",
      validator: (value) => ["small", "medium", "big"].includes(value),
    },
  },
};
</script>

<style lang="scss" module>
@use "@/styles/mixins/typography";

.avatar {
  display: inline-flex;
  flex-shrink: 0;

  img,
  span {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }

  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

.small {
  width: 20px;
  height: 20px;

  span {
    @include typography.extra-small;
  }
}

.medium {
  width: 24px;
  height: 24px;

  span {
    @include typography.extra-small;
  }
}

.big {
  width: 32px;
  height: 32px;

  span {
    @include typography.small;
  }
}
</style>
